import React from "react";
import { apiUbahPembagian, formatApiErrorDetail } from "@/lib/api";
import AlihkanPanel from "@/components/AlihkanPanel";

const inputCls = "rounded border border-slate-700 bg-slate-950 px-2 py-1 text-sm text-slate-100";
const STATUS = { PENDING: "menunggu", IN_PROGRESS: "dikerjakan", COMPLETED: "selesai" };

// T2-C: the tailors' parts of a Cutting & Jahit step (current round). The
// Owner changes the split of parts not started yet (T1, reason required) or
// moves one part to another tailor (T2: only the Owner).
export default function BagianPanel({ detail, wi, s, isAdmin, onChanged }) {
  const bagian = (s.bagian || []).filter((b) => (b.putaran || 0) === (s.putaran || 0));
  const belum = bagian.filter((b) => b.status === "PENDING");
  const [ubah, setUbah] = React.useState(null);  // {pcs: {id: n}, alasan}
  const [alih, setAlih] = React.useState(null);
  const [error, setError] = React.useState(null);
  if (!bagian.length) return null;
  const total = belum.reduce((n, b) => n + b.pcs, 0);
  const mulaiUbah = () => {
    const pcs = {};
    belum.forEach((b) => { pcs[b.operator.id] = (pcs[b.operator.id] || 0) + b.pcs; });
    setUbah({ pcs, alasan: "" }); setError(null);
  };
  const isi = ubah ? Object.entries(ubah.pcs).map(([id, n]) => ({ operator_id: id, pcs: Number(n) || 0 })) : [];
  const jumlah = isi.reduce((n, a) => n + a.pcs, 0);
  const simpan = async () => {
    setError(null);
    try { await apiUbahPembagian(detail.spk_id, wi.instance_id, s.urutan, { alokasi: isi.filter((a) => a.pcs > 0), alasan: ubah.alasan }); setUbah(null); onChanged(); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  return (
    <div data-testid={`bagian-panel-${s.pos_code}`} className="mt-3 rounded-lg border border-slate-800 p-3 space-y-2 text-sm">
      <div className="text-[13px] font-semibold text-slate-500">Bagian per penjahit{s.putaran ? ` · rework ke-${s.putaran}` : ""}</div>
      <table className="w-full text-sm"><tbody>
        {bagian.map((b) => (
          <tr key={b.id} className="border-t border-slate-800/60">
            <td className="py-1">{b.operator?.nama || b.operator?.username}</td>
            <td className="py-1 font-mono">{b.pcs} pcs</td>
            <td className="py-1 text-xs text-slate-400">{STATUS[b.status] || b.status}{b.form?.qty ? ` · hasil ${b.form.qty.hasil}` : ""}</td>
            <td className="py-1 text-right">{isAdmin && b.status !== "COMPLETED" && (
              <button data-testid={`bagian-alihkan-${b.operator?.username}`} onClick={() => setAlih({ spk_id: detail.spk_id, nomor_spk: detail.nomor_spk, instance_id: wi.instance_id, urutan: s.urutan, pos_code: s.pos_code, pos_nama: s.pos_nama, bagian_id: b.id, bagian_pcs: b.pcs, started_by_username: b.operator?.username })}
                className="rounded border border-amber-500/40 px-2 py-0.5 text-xs text-amber-300">Alihkan</button>)}</td>
          </tr>
        ))}
      </tbody></table>
      {alih && <AlihkanPanel item={alih} onClose={() => setAlih(null)} onDone={() => { setAlih(null); onChanged(); }} />}
      {isAdmin && belum.length > 0 && !ubah && <button data-testid="bagian-ubah" onClick={mulaiUbah} className="rounded border border-cyan-500/40 px-2.5 py-1 text-xs text-cyan-300">Ubah pembagian ({total} pcs belum dimulai)</button>}
      {ubah && (
        <div data-testid="bagian-ubah-form" className="space-y-1.5 rounded border border-cyan-500/30 p-2">
          {(detail.penjahit_aktif || []).map((p) => (
            <label key={p.id} className="flex items-center gap-2 text-xs text-slate-300"><span className="w-40 truncate">{p.nama || p.username}</span>
              <input data-testid={`bagian-ubah-${p.username}`} type="number" min="0" value={ubah.pcs[p.id] ?? ""} onChange={(e) => setUbah({ ...ubah, pcs: { ...ubah.pcs, [p.id]: e.target.value } })} className={`${inputCls} w-20`} /> pcs</label>
          ))}
          <input data-testid="bagian-ubah-alasan" value={ubah.alasan} maxLength={300} onChange={(e) => setUbah({ ...ubah, alasan: e.target.value })} placeholder="Alasan (wajib)" className={`${inputCls} w-full`} />
          <div className={`text-xs ${jumlah === total ? "text-emerald-300" : "text-amber-300"}`}>Jumlah {jumlah} dari {total} pcs</div>
          {error && <p className="text-xs text-red-300">{error}</p>}
          <div className="flex gap-2">
            <button data-testid="bagian-ubah-simpan" disabled={jumlah !== total || ubah.alasan.trim().length < 5} onClick={simpan} className="rounded bg-cyan-500 px-3 py-1 text-xs font-semibold text-slate-950 disabled:opacity-40">Simpan</button>
            <button onClick={() => setUbah(null)} className="rounded border border-slate-700 px-3 py-1 text-xs text-slate-300">Batal</button>
          </div>
        </div>
      )}
    </div>
  );
}
